<template>
<nav class="breadcrumb is-center" aria-label="breadcrumbs">
    <ul>
        <li>
            <a href="#About">About</a>
        </li>
        <li>
            <a href="#qualification">qualification</a>
        </li>
        <li>
            <a href="#Contact">contact</a>
        </li>

    </ul>

</nav>
</template>
<script>

export default {
    name: 'HeaderComponent',

}
</script>

<style>
nav {
    position: absolute;

    width: 100%;
    line-height: 1.4em;
}

ul {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    text-align: center;
    margin-bottom: -1.4em;
}
li{
    list-style: none;
    font-size: 150%;
    
    text-align: center;
}

ul:after {
    content: "";

    color: rgb(20, 182, 33);
    display: inline-block;
    width: 100%;
}
nav>a {
    font-weight: bold;
    color: #2c3e50;
    /* &.router-link-exact-active {
    color: #42b983;
  } */
}

html {
    position: relative;
    min-height: 100%;
}

body {
    margin-bottom: 60px;
    /* Margin bottom by footer height */
}

.imagehead {
    position: fixed;
    top: 0%;
    width: 25%;
    height: 35%;

}
</style>
